import { useTranslation } from "react-i18next";
import { Text } from "@fragments";

import { IconCurrencyReal } from "@tabler/icons-react";

import "./styles.scss";

export default function SplitCurrencyNotice() {
  const { t } = useTranslation("settings");

  return (
    <div className="split-currency-notice">
      <div className="split-currency-notice__icon">
        <IconCurrencyReal />
      </div>
      <div className="split-currency-notice__copy">
        <Text.label contrast={9}>
          {t("split.currencyNotice.title")}
        </Text.label>
        <Text.span contrast={6}>
          {t("split.currencyNotice.description")}
        </Text.span>
      </div>
    </div>
  );
}
